import { render, staticRenderFns } from "./AttributesTree.vue?vue&type=template&id=3e1fe51e&scoped=true"
import script from "./AttributesTree.vue?vue&type=script&lang=js"
export * from "./AttributesTree.vue?vue&type=script&lang=js"
import style0 from "./AttributesTree.vue?vue&type=style&index=0&id=3e1fe51e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e1fe51e",
  null
  
)

export default component.exports